<template>
<div id="overview">
    <div class="_el_min">
        <el-row>
            <el-col :span="24">
                <div class="_div">
                    <h1 class="title">專案名稱</h1>
                    <ul class="_ul" :style=" !ischoose ? 'position: absolute;right:0px;' : 'position: absolute;right:94px;'">
                        <li @click="clickLiColor('0')" :class="{ liBackColor: isLiBackColor === '0' }">過去 7 天</li>
                        <li @click="clickLiColor('1')" :class="{ liBackColor: isLiBackColor === '1' }">過去 30 天</li>
                        <li @click="clickLiColor('2')" :class="{ liBackColor: isLiBackColor === '2' }">過去 1 年</li>
                        <li>
                          <div class="block" :class="{blockChose: ischoose === true}">
                              <el-date-picker
                                v-model="value6"
                                format="MM月dd日"
                                :type="daterange"
                                @focus="pickerFunc"
                                @blur="blurFunc"
                                ref="picker"
                                :editable="false"
                              >
                              </el-date-picker>
                        </div>
                      </li>
                    </ul>
                </div>

            </el-col>
        </el-row>
        <el-row style="margin-top: 24px;">
            <el-col :span="24">
                <div class="base">
                    <div>
                      <h1 class="sumTitle">533,542</h1>
                      <p>
                        <span class="titleName">下載次數</span>
                        <img src="" alt="">
                      </p>
                    </div>
                    <div id="myChart" ref="myChart"></div>
                </div>
            </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
            <el-col :span="24">
                <div style="display: flex;justify-content: space-between;">
                  <div class="baseChildOne">
                  <div>
                      <h1 class="sumTitle" style="margin-top:10px;">3,192</h1>
                      <p>
                        <span class="titleName">安裝次數</span>
                        <img src="" alt="">
                      </p>
                    </div>
                    <div id="ehartLeft" ref="ehartLeft"></div>
                  </div>
                  <div class="baseChildSecond">
                    <div>
                      <h1 class="sumTitle" style="margin-top:10px;">402</h1>
                      <p>
                        <span class="titleName">解除安裝次數</span>
                        <img src="" alt="">
                      </p>
                    </div>
                    <div id="ehartRight" ref="ehartRight"></div>
                  </div>
                </div>
            </el-col>
        </el-row>
    </div>
</div>
</template>
<script>
import echarts from 'echarts'
export default {
    data () {
        return {
            routes: [],
            echartsDta: null,
            pickerOptions2: {
                shortcuts: [
                    {
                        text: 'Last week',
                        onClick (picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: 'Last month',
                        onClick (picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: 'Last 3 months',
                        onClick (picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            },
            value6: '',
            daterange: 'daterange',
            clear: '',
            ischoose: false,
            elIconDate: ' ',
            isLiBackColor: '',
            // 这是echarts
            Max: null,
            arrlist: null,
            data: [],
            appId: ''
        }
    },
    methods: {
    // header 导航事件
        headerNavMainFunc (path) {
            this.isFlagIconClass = null
            this.routes.forEach(item => {
                if (item.path === path) {
                    this.navRouterState(item)
                }
            })
        },
        clickLiColor (type) {
            this.isLiBackColor = type
            this.pickerStyle(0, true)
            this.value6 = ''
        },
        pickerFunc () {
            this.ischoose = true
            this.isLiBackColor = null
            this.elIconDate = 'el-icon-date'
        },
        blurFunc () {
            if (!this.value6) {
                this.ischoose = false
                this.elIconDate = ' '
            }
        },
        draw () {
            // 实例化echarts对象
            let myChart = echarts.init(this.$refs.myChart)
            // 绘制条形图
            myChart.setOption({
                // 控制内容得padding
                grid: {
                    x: 70,
                    y: 40,
                    x2: 35,
                    y2: 26,
                    borderWidth: 1,
                    borderColor: '#dedede'
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: (param, ticket, callback) => {
                        // 用定时器模拟异步事件
                        setTimeout(function () {
                            var res = `<div>
              <p style="padding:0px;margin:0px;">日期: ${param[0].name}</p>
              <p style="padding:0px;margin:0px;">下载: ${param[0].value}</p>
              </div>`
                            callback(ticket, res)
                        }, 500)
                        return 'loading' // 内容还没返回时显示的内容
                    },
                    textStyle: {
                        align: 'left',
                        // 提示框颜色
                        color: '#333333',
                        fontFamily: 'NotoSansCJKtc',
                        fontSize: 12
                        // color:'rgba(0, 224, 218, 0.3)'
                    },
                    // 提示框背景色
                    backgroundColor: '#FFFFFF',
                    // 提示框的边框
                    borderWidth: 1,
                    // 提示框的边框色
                    borderColor: '#d6d6d6',
                    // 提示框 内边距
                    padding: [3, 5],
                    // 这是那根标尺线 样式
                    position: function (point, params, dom) {
                        // point[0] // x轴：- 往左 + 往右
                        // point[1] // y轴：- 往上 + 往下
                        return [point[0] - 25, point[1] + 20]
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            // color: "hsla(240, 0%, 50%, 0.3)",
                            // 这是标识杆的颜色
                            color: 'rgba(0, 224, 218, 0.3)',
                            width: 2,
                            type: 'solid'
                        }
                    }
                },
                // X轴
                xAxis: {
                    data: this.arrlist,
                    splitLine: {
                        // show: false
                    },
                    // x轴的样式
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#333333',
                            width: 1
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            // color: "hsla(240, 0%, 50%, 0.3)"
                            // x轴字体颜色
                            color: '#333333',
                            fontSize: 12,
                            fontFamily: 'NotoSansCJKtc',
                            fontWeight: 300,
                            fontStyle: 'normal',
                            letterSpacing: 0.8
                        },
                        interval: 0
                    }
                    // 改变坐标轴的样式
                },
                // Y轴
                yAxis: {
                    type: 'value',
                    nameTextStyle: {
                        fontFamily: 'NotoSansCJKtc',
                        color: 'red'
                    },
                    // name: "hihi",
                    min: 0,
                    max: this.Max, // 计算最大值
                    interval: Math.ceil(this.Max / 6),
                    axisLabel: {
                        show: true,
                        // 这是再设置y轴的参数 自定义
                        formatter: function (value, api) {
                            // console.log(api, value)
                            var texts = []
                            if (api === 0) {
                            } else if (api === 1) {
                                texts.push(0)
                            } else if (api === 2) {
                                texts.push(2)
                            } else if (api === 3) {
                                texts.push(4)
                            } else if (api === 4) {
                                texts.push(6)
                            } else if (api === 5) {
                                texts.push(8)
                            } else {
                                texts.push(1000)
                            }
                            return texts
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: { type: 'dashed' }
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    position: 'bottom'
                    // color: "hsla(240, 0%, 50%, 0.3)"
                    // x轴字体颜色
                },
                // 数据
                series: [
                    {
                        // name: "裤子",
                        type: 'line',
                        // data: [200, 2001, 3100, 1401, 260, 1, 20, 300, 2000, 200, 222],
                        data: this.data,
                        showSymbol: true,
                        symbol: 'circle', // 实心点
                        symbolSize: 5, // 实心点大小
                        // 实心点的颜色
                        itemStyle: {
                            normal: {
                                // color: "hsla(240, 0%, 50%, 0.7)",
                                color: '#00b5e2',
                                // 折线的样式
                                lineStyle: { color: '#00b5e2', width: 1.6 }
                            }
                        }
                    }
                ]
            })
        },
        drawLeft () {
            // 实例化echarts对象
            let myChart = echarts.init(this.$refs.ehartLeft)
            // 绘制条形图
            myChart.setOption({
                // 控制内容得padding
                grid: {
                    x: 50,
                    y: 40,
                    x2: 18,
                    y2: 32,
                    borderWidth: 1,
                    borderColor: '#dedede'
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: (param, ticket, callback) => {
                        // 用定时器模拟异步事件
                        setTimeout(function () {
                            var res = `<div>
              <p style="padding:0px;margin:0px;">日期: ${param[0].name}</p>
              <p style="padding:0px;margin:0px;">下载: ${param[0].value}</p>
              </div>`
                            callback(ticket, res)
                        }, 500)
                        return 'loading' // 内容还没返回时显示的内容
                    },
                    textStyle: {
                        align: 'left',
                        // 提示框颜色
                        color: '#333333',
                        fontFamily: 'NotoSansCJKtc',
                        fontSize: 12
                        // color:'rgba(0, 224, 218, 0.3)'
                    },
                    // 提示框背景色
                    backgroundColor: '#FFFFFF',
                    // 提示框的边框
                    borderWidth: 1,
                    // 提示框的边框色
                    borderColor: '#d6d6d6',
                    // 提示框 内边距
                    padding: [3, 5],
                    // 这是那根标尺线 样式
                    position: function (point, params, dom) {
                        return [point[0] - 25, point[1] + 20]
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            // color: "hsla(240, 0%, 50%, 0.3)",
                            // 这是标识杆的颜色
                            color: 'rgba(0, 224, 218, 0.3)',
                            width: 2,
                            type: 'solid'
                        }
                    }
                },
                // X轴
                xAxis: {
                    data: this.arrlist,
                    splitLine: {
                        // show: false
                    },
                    // x轴的样式
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#333333',
                            width: 1
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            // color: "hsla(240, 0%, 50%, 0.3)"
                            // x轴字体颜色
                            color: '#333333',
                            fontSize: 12,
                            fontFamily: 'NotoSansCJKtc',
                            fontWeight: 300,
                            fontStyle: 'normal',
                            letterSpacing: 0.8
                        },
                        interval: 0
                    }
                    // 改变坐标轴的样式
                },
                // Y轴
                yAxis: {
                    type: 'value',
                    nameTextStyle: {
                        fontFamily: 'NotoSansCJKtc',
                        color: 'red'
                    },
                    // name: "hihi",
                    min: 0,
                    max: this.Max, // 计算最大值
                    interval: Math.ceil(this.Max / 6),
                    axisLabel: {
                        show: true,
                        // 这是再设置y轴的参数 自定义
                        formatter: function (value, api) {
                            // console.log(api, value)
                            var texts = []
                            if (api === 0) {
                            } else if (api === 1) {
                                texts.push(0)
                            } else if (api === 2) {
                                texts.push(2)
                            } else if (api === 3) {
                                texts.push(4)
                            } else if (api === 4) {
                                texts.push(6)
                            } else if (api === 5) {
                                texts.push(8)
                            } else {
                                texts.push(1000)
                            }
                            return texts
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: { type: 'dashed' }
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    position: 'bottom'
                    // color: "hsla(240, 0%, 50%, 0.3)"
                    // x轴字体颜色
                },
                // 数据
                series: [
                    {
                        // name: "裤子",
                        type: 'line',
                        // data: [200, 2001, 3100, 1401, 260, 1, 20, 300, 2000, 200, 222],
                        data: this.data,
                        showSymbol: true,
                        symbol: 'circle', // 实心点
                        symbolSize: 5, // 实心点大小
                        // 实心点的颜色
                        itemStyle: {
                            normal: {
                                // color: "hsla(240, 0%, 50%, 0.7)",
                                color: '#00b5e2',
                                // 折线的样式
                                lineStyle: { color: '#00b5e2', width: 1.6 }
                            }
                        }
                    }
                ]
            })
        },
        drawRight () {
            // 实例化echarts对象
            let myChart = echarts.init(this.$refs.ehartRight)
            // 绘制条形图
            myChart.setOption({
                // 控制内容得padding
                grid: {
                    x: 50,
                    y: 40,
                    x2: 18,
                    y2: 32,
                    borderWidth: 1,
                    borderColor: '#dedede'
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: (param, ticket, callback) => {
                        // 用定时器模拟异步事件
                        setTimeout(function () {
                            var res = `<div>
              <p style="padding:0px;margin:0px;">日期: ${param[0].name}</p>
              <p style="padding:0px;margin:0px;">下载: ${param[0].value}</p>
              </div>`
                            callback(ticket, res)
                        }, 500)
                        return 'loading' // 内容还没返回时显示的内容
                    },
                    textStyle: {
                        align: 'left',
                        // 提示框颜色
                        color: '#333333',
                        fontFamily: 'NotoSansCJKtc',
                        fontSize: 12
                        // color:'rgba(0, 224, 218, 0.3)'
                    },
                    // 提示框背景色
                    backgroundColor: '#FFFFFF',
                    // 提示框的边框
                    borderWidth: 1,
                    // 提示框的边框色
                    borderColor: '#d6d6d6',
                    // 提示框 内边距
                    padding: [3, 5],
                    // 这是那根标尺线 样式
                    position: function (point, params, dom) {
                        return [point[0] - 25, point[1] + 20]
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            // color: "hsla(240, 0%, 50%, 0.3)",
                            // 这是标识杆的颜色
                            color: 'rgba(0, 224, 218, 0.3)',
                            width: 2,
                            type: 'solid'
                        }
                    }
                },
                // X轴
                xAxis: {
                    data: this.arrlist,
                    splitLine: {
                        // show: false
                    },
                    // x轴的样式
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#333333',
                            width: 1
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            // color: "hsla(240, 0%, 50%, 0.3)"
                            // x轴字体颜色
                            color: '#333333',
                            fontSize: 12,
                            fontFamily: 'NotoSansCJKtc',
                            fontWeight: 300,
                            fontStyle: 'normal',
                            letterSpacing: 0.8
                        },
                        interval: 0
                    }
                    // 改变坐标轴的样式
                },
                // Y轴
                yAxis: {
                    type: 'value',
                    nameTextStyle: {
                        fontFamily: 'NotoSansCJKtc',
                        color: 'red'
                    },
                    // name: "hihi",
                    min: 0,
                    max: this.Max, // 计算最大值
                    interval: Math.ceil(this.Max / 6),
                    axisLabel: {
                        show: true,
                        // 这是再设置y轴的参数 自定义
                        formatter: function (value, api) {
                            // console.log(api, value)
                            var texts = []
                            if (api === 0) {
                            } else if (api === 1) {
                                texts.push(0)
                            } else if (api === 2) {
                                texts.push(2)
                            } else if (api === 3) {
                                texts.push(4)
                            } else if (api === 4) {
                                texts.push(6)
                            } else if (api === 5) {
                                texts.push(8)
                            } else {
                                texts.push(1000)
                            }
                            return texts
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: { type: 'dashed' }
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    position: 'bottom'
                    // color: "hsla(240, 0%, 50%, 0.3)"
                    // x轴字体颜色
                },
                // 数据
                series: [
                    {
                        type: 'line',
                        data: this.data,
                        showSymbol: true,
                        symbol: 'circle', // 实心点
                        symbolSize: 5, // 实心点大小
                        // 实心点的颜色
                        itemStyle: {
                            normal: {
                                // color: "hsla(240, 0%, 50%, 0.7)",
                                color: '#00b5e2',
                                // 折线的样式
                                lineStyle: { color: '#00b5e2', width: 1.6 }
                            }
                        }
                    }
                ]
            })
        },
        pickerStyle (type, flag) {
            let dom = this.$refs.picker.$el
            let childNodes = dom.childNodes
            let display, color, backColor
            if (type === 0) {
                display = 'none'
                if (childNodes.length < 6) {
                    let span = document.createElement('span')
                    span.innerText = '自訂範圍'
                    span.style.marginLeft = '11px'
                    dom.appendChild(span)
                }
                if (flag) {
                    color = '#333'
                    backColor = '#fff'
                } else {
                    color = '#fff'
                    backColor = '#00b5e2'
                }
                childNodes[5].style.backgroundColor = backColor
                childNodes[5].style.color = color
                childNodes[5].style.lineHeight = '38px'
                childNodes[5].style.display = 'block'
            } else {
                display = 'block'
                backColor = '#00b5e2'
                childNodes[0].style.color = '#fff'
                childNodes[1].style.backgroundColor = '#00b5e2'
                childNodes[1].style.color = '#fff'
                childNodes[2].style.color = '#fff'
                childNodes[2].style.width = '10px'
                childNodes[3].style.backgroundColor = '#00b5e2'
                childNodes[3].style.color = '#fff'
                childNodes[4].style.color = '#fff'
                if (childNodes.length === 6) {
                    childNodes[5].style.display = 'none'
                }
            }
            for (let i = 0; i < 5; i++) {
                childNodes[i].style.display = display
            }
            dom.style.backgroundColor = backColor
        },
        getData () {
            if (this.$route.query.appId) {
                this.appId = this.$route.query.appId
                this.$store.state.appId = this.appId
            } else {
                this.appId = this.$store.state.appId
            }
            const path = `/developer/${this.appId}/downloadLine/report`
            this._api
                .request('get', path)
                .then(res => {
                    // this.tableData2 = res.data.data.payload;
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    mounted () {
        this.echartsDta = this.$route.params
        let secondNavItem = [
            { path: 'overView', msg: 'header.secondFloor.route.name.overview' },
            true,
            { path: 'echarts', msg: 'header.secondFloor.route.name.detailAnalysis' }
        ]
        this.$store.state.secondNavItem = secondNavItem
        let routes = this.$router.options.routes
        this.routes = routes
            .filter(
                item =>
                    item.hasOwnProperty('meta') && item.meta.hasOwnProperty('navObj')
            )
            .map(item => item.meta.navObj)
        // pickDate
        this.pickerStyle(0, true)
        // 调用绘制图表的方法
        let data = [
            0,
            2001,
            3100,
            1401,
            260,
            1,
            20,
            300,
            2000,
            2050,
            222,
            100,
            2033,
            3213,
            4251,
            3224,
            2393
        ]
        let Max = Math.max.apply(null, data) // 最大值
        this.Max = Max
        let arrlist = []
        for (let i = 1; i < 18; i++) {
            if (18 % i === 3) {
                let j = i + 'day'
                arrlist.push(j)
            } else {
                arrlist.push(' ')
            }
        }
        this.arrlist = arrlist
        this.data.push(
            data.map(item => {
                return item + '新台币'
            })
        )
        this.data = data
        // big
        this.draw()
        // small
        this.drawLeft()
        this.drawRight()
        if (sessionStorage.getItem('appId')) {
            this.$store.state.appId = sessionStorage.getItem('appId')
        }
        this.getData()
    },
    beforeUpdate () {
        if (!this.value6) {
            this.ischoose = false
            this.elIconDate = ' '
            this.pickerStyle(0)
        } else if (this.value6) {
            this.ischoose = true
            this.elIconDate = 'el-icon-date'
            this.pickerStyle(1)
        }
        if (this.isLiBackColor) {
            this.pickerStyle(0, true)
        }
    },
    destroyed () {
        this.$store.state.appId = this.appId
    }
}
</script>
<style>
#overview .el-range-editor.el-input__inner {
  width: 100%;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
}

#overview .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
#overview .el-date-editor .el-range-separator {
  display: none;
}
</style>

<style scoped>
li {
  list-style: none;
  display: inline-block;
  width: 80px;
  text-align: center;
}
._ul {
  margin: 0;
  border-radius: 4px;
  padding: 0px;
}
p {
  margin: 0px;
}
h1 {
  margin: 0px;
}
#myChart {
  width: 100%;
  height: 220px;
  font-size: 12px;
  color: red !important;
}
#ehartLeft {
  width: 100%;
  height: 200px;
  font-size: 12px;
}
#ehartRight {
  width: 100%;
  height: 200px;
  font-size: 12px;
}
.sumTitle {
  height: 59px;
  font-family: sans-serif;
  font-size: 40px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.2px;
  color: #333333;
  margin: 20px 0px 0px 30px;
}
.titleName {
  width: 316px;
  height: 24px;
  font-family: sans-serif;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.9px;
  color: #333333;
  margin: 0px 10px 0px 30px;
}
._ul li {
  width: 111px;
  height: 38px;
  background-color: #ffffff;
  border: 1px solid rgba(51, 51, 51, 0.2);
  border-right: none;
  line-height: 38px;
  cursor: pointer;
}
._ul li:nth-child(1) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
._ul li:nth-child(4) {
  border-left: none;
  border-top: none;
}
#overview .liBackColor {
  background-color: #00b5e2;
  color: #ffffff;
}
.block {
  width: 111px;
  position: relative;
  right: 0px;
}
.blockChose {
  width: 205px;
}
._div {
  text-align: right;
  display: flex;
  line-height: 56px;
  justify-content: space-between;
  margin-top: 17px;
}
#overview {
  width: 895px;
  margin: auto;
  margin-bottom: 100px;
}
#overview .title {
  height: 56px;
  font-family: sans-serif;
  font-size: 38px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.1px;
  color: #333333;
  margin: 0px;
}
.base {
  width: 895px;
  height: 360px;
  border-radius: 8px;
  box-shadow: 0 2px 1px 0 rgba(51, 51, 51, 0.2);
  background-color: #ffffff;
  border: 1px solid rgba(51, 51, 51, 0.2);
}
.baseChildOne {
  width: 440px;
  /* height: 330px; */
  border-radius: 8px;
  box-shadow: 0 2px 1px 0 rgba(51, 51, 51, 0.2);
  background-color: #ffffff;
  border: 1px solid rgba(51, 51, 51, 0.2);
}
.baseChildSecond {
  width: 440px;
  /* height: 330px; */
  border-radius: 8px;
  box-shadow: 0 2px 1px 0 rgba(51, 51, 51, 0.2);
  background-color: #ffffff;
  border: 1px solid rgba(51, 51, 51, 0.2);
}
</style>
